import enterpriseComponentClassFactory from "../eoec/EnterpriseComponentClassFactory";
import EnterpriseComponent from "../eoec/ec/EnterpriseComponent";

export const updateObject = (a: any, b: any) => ({...a, ...b});

export function makeEnterpriseComponent(name: string) {
    let enterpriseComponentObject: object | undefined = enterpriseComponentClassFactory(name);
    // @ts-ignore
    return new (enterpriseComponentObject)(name) as EnterpriseComponent;
}